export const URLS = {
  helpAticles: {
    bcmsMovements: "http://help.breedr.co/en/articles/4342655-bcms-movements-are-now-available",
  },
};
